import palette from './palette';

const driverDetailsStyles = (theme) => ({
  ...theme,
  palette: {
    ...theme.palette,
    primary: {
      ...theme.palette.primary,
      main: palette.blue,
    },
    secondary: {
      ...theme.palette.secondary,
      main: palette.typography.black.solid,
    },
  },
  overrides: {
    ...theme.overrides,
    MuiGrid: {
      container: {
        padding: '0.2rem 0',
      },
    },
  },
});

export default driverDetailsStyles;
